import React, { useState } from "react";
import { Modal, Spin, Row, Col } from "antd";
import MyButton from "../../components/Button";
import useIsDesktop from "../../utils/hooks/useIsDesktop";
import {
  ExclamationCircleFilled,
  ExclamationCircleOutlined,
} from "@ant-design/icons";
import { LoadingOutlined } from "@ant-design/icons";

import "./modal.css";
import { COLORS } from "../../constants/Colors";
import Typography from "../../components/Typography";
import { FormattedMessage, useIntl } from "react-intl";

const ModalconfirmChangepassword = (props) => {
  const { confirmChangepassword, handleOk, isCloseComfirmPassword } = props;
  const isDesktop = useIsDesktop();

  const [isLoading, setIsloading] = useState(false);
  const intl = useIntl();

  const { confirm } = Modal;

  // Styles for the modal content to align the text in the middle
  const modalContentStyles = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginTop: isDesktop ? "25px" : "340px",
  };

  const confirma = () => {
    setIsloading(true);
    setTimeout(() => {
      handleOk();
      setIsloading(false);
    }, 780);
  };

  const antIcon = (
    <LoadingOutlined
      style={{
        fontSize: 36,
      }}
      spin
    />
  );

  return (
    <>
      {isDesktop && isDesktop ? (
        <Modal
          open={confirmChangepassword}
          onOk={handleOk}
          onCancel={isCloseComfirmPassword}
          width={350}
          className="custom-modal-password"
          footer={[
            <div>
              <MyButton
                onClick={isCloseComfirmPassword}
                style={{
                  width: isDesktop ? "30%" : "30%",
                  marginLeft: "0px",
                  marginTop: "0px",
                  marginRight: "5px",
                }}
              >
                <FormattedMessage id="btnCancel" defaultMessage="Cancel" />
              </MyButton>{" "}
              <MyButton
                isPrimary
                onClick={handleOk}
                style={{
                  width: isDesktop ? "30%" : "30%",
                  marginInlineStart: "0px",
                }}
              >
                <FormattedMessage id="btnOK" defaultMessage="Ok" />
              </MyButton>
            </div>,
          ]}
          centered
        >
          {isLoading === false ? (
            <div style={{ height: "100px" }}>
              <Typography
                isBold
                size="16px"
                color={COLORS.Primary}
                className="text-center p-2"
              >
                <FormattedMessage
                  id="modalConfirmChangePassword"
                  defaultMessage="Confirm Change Password"
                />
              </Typography>
              <Typography className="text-center p-3">
                <FormattedMessage
                  id="titleConfirmChangePassword"
                  defaultMessage="Are you sure you want to change your password ?"
                />
              </Typography>
            </div>
          ) : (
            <div>
              <Spin indicator={antIcon} />
            </div>
          )}
        </Modal>
      ) : (
        <Modal
          open={confirmChangepassword}
          onOk={handleOk}
          onCancel={isCloseComfirmPassword}
          className="custom-modal-password"
          width={350}
          centered={true}
          style={{
            marginTop: "70%",
          }}
          styles={{
            body: {
              height: "15vh",
            },
          }}
          footer={[
            <div>
              <MyButton
                onClick={isCloseComfirmPassword}
                style={{
                  width: isDesktop ? "25%" : "30%",
                  marginLeft: "0px",
                  marginTop: "8px",
                }}
              >
                <FormattedMessage id="btnCancel" defaultMessage="Cancel" />
              </MyButton>{" "}
              <MyButton
                isPrimary
                onClick={handleOk}
                style={{
                  width: isDesktop ? "25%" : "30%",
                  marginInlineStart: "0px",
                }}
              >
                <FormattedMessage id="btnOK" defaultMessage="Ok" />
              </MyButton>
            </div>,
          ]}
        >
          {isLoading === false ? (
            <div>
              <Typography
                isBold
                size="16px"
                color={COLORS.Primary}
                className="text-center p-2"
              >
                <FormattedMessage
                  id="modalConfirmChangePassword"
                  defaultMessage="Confirm Change Password"
                />
              </Typography>
              <Typography className="text-center p-3">
                <FormattedMessage
                  id="titleConfirmChangePassword"
                  defaultMessage="Are you sure you want to change your password ?"
                />
              </Typography>
            </div>
          ) : (
            <div>
              <Spin indicator={antIcon} />
            </div>
          )}
        </Modal>
      )}
    </>
  );
};

export default ModalconfirmChangepassword;
